import Vue from 'vue'
import VueRouter from 'vue-router'
const spread = () => import('@/views/spread')
const home = () => import('@/views/home')
const payment = () => import('@/views/payment')
const querys = () => import('@/views/query')

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'chengnuo',
  meta: {
    title: '承诺书',
    requireAuth: true,
  },
  component: spread
},{
    path: '/home',
    name: 'home',
    meta: {
      title: '报名',
      requireAuth: true,
    },
    component: home
  },{
    path: '/querys',
    name: 'querys',
    meta: {
      title: '查询',
      requireAuth: true,
    },
    component: querys
  },{
    path: '/payment/',
    name: 'payment',
    meta: {
      title: '缴费',
      requireAuth: true,
    },
    component: payment
  }]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router